import { RequestDefinition } from 'libraries/front-end-core/core/Api'
import {
  URL_MW_EVENT_TYPES,
  URL_MW_FEATURED_DEAL,
  URL_MW_LATEST_DEALS,
  URL_MW_STATS_SUMMARY,
  URL_MW_EVENT_CONFIGURATION,
  URL_MW_SHARED_EVENTS_CONFIGURATION,
  URL_MW_LIST_DEALS,
  URL_MW_STATS,
  URL_MW_DEAL
} from 'constants/urls'
import {
  MW_EVENT_TYPES,
  MW_FEATURED_DEAL,
  MW_LATEST_DEALS,
  MW_STATS_SUMMARY,
  MW_EVENT_CONFIGURATION,
  MW_SHARED_EVENTS_CONFIGURATION,
  MW_LIST_DEALS,
  MW_STATS,
  MW_DEAL
} from 'constants/requests'
import {
  toEventTypes,
  toFeaturedDeal,
  toLatestDeals,
  toStatsSummary,
  toEventConfiguration,
  toSharedEventsConfiguration,
  toListDeals,
  toStats,
  toDeal
} from './transform'

export const FeaturedDeal = new RequestDefinition({
  name: MW_FEATURED_DEAL,
  url: URL_MW_FEATURED_DEAL,
  transform: toFeaturedDeal
})

export const LatestDeals = new RequestDefinition({
  name: MW_LATEST_DEALS,
  url: URL_MW_LATEST_DEALS,
  transform: toLatestDeals,
  cacheTtl: 0
})

export const StatsSummary = new RequestDefinition({
  name: MW_STATS_SUMMARY,
  url: URL_MW_STATS_SUMMARY,
  transform: toStatsSummary
})

export const EventTypes = new RequestDefinition({
  name: MW_EVENT_TYPES,
  url: URL_MW_EVENT_TYPES,
  transform: toEventTypes
})

export const EventConfiguration = new RequestDefinition({
  name: MW_EVENT_CONFIGURATION,
  url: URL_MW_EVENT_CONFIGURATION,
  transform: toEventConfiguration
})

export const SharedEventsConfiguration = new RequestDefinition({
  name: MW_SHARED_EVENTS_CONFIGURATION,
  url: URL_MW_SHARED_EVENTS_CONFIGURATION,
  transform: toSharedEventsConfiguration
})

export const ListDeals = new RequestDefinition({
  name: MW_LIST_DEALS,
  url: URL_MW_LIST_DEALS,
  transform: toListDeals,
  cacheTtl: 0
})

export const Stats = new RequestDefinition({
  name: MW_STATS,
  url: URL_MW_STATS,
  transform: toStats
})

export const Deal = new RequestDefinition({
  name: MW_DEAL,
  url: URL_MW_DEAL,
  transform: toDeal
})
